/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-04-20 09:30:35
 * @FilePath: \baishu_react_ui\src\components\BsyIconBtn\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import BsyAlertTip from '../../Login/BsyAlertTip';
import { BsyUtils } from '../../utils/Utils';
import BsyButton from '../BsyButton';
import { BsyWidget } from '../BsyWidget';
import './index.css';

export default class BsyLocation extends BsyWidget {

    constructor(props) {
        super({
            allowBlank: !0,
            locationText: React.language("widget.location.get"),
            hasBrief: !0,
            btnWidth: 350,
            btnHeight: 34,
            isValueVisible: !0,
            enablePcLocation: !1,
            baseCls: "bsy-location",
            ...props,
        });

        this.map = null;
        this.AMap = {};
        this.state = {
            showMap: false,
            hasAMap: true,
        }

        this.addressText = React.createRef();
        this.latRef = React.createRef();
        this.lonRef = React.createRef();
        window.zIndex++
        this.zIndex = window.zIndex;
        this.lnglatXY = null;
    }

    componentDidMount() {
        super.componentDidMount()
        const { enablePcLocation } = this.options;

        if (this.isEnabled()) {
            if (enablePcLocation) {
                this.initMap()
            }
        }
    }

    initMap = () => {
        const { autoLocation } = this.options;
        this.AMap = window.AMap;
        if (this.AMap) {
            const AMap = this.AMap;
            this.map = new AMap.Map("DashMap-" + this.zIndex, { //设置地图容器id
                resizeEnable: !0,
                dragEnable: !1,
                doubleClickZoom: !1,
                zooms: [15, 17]
            });

            this.mapCenter = this.map.getCenter()
            AMap.plugin(['AMap.Geocoder'], () => { //回调函数
                if (!this.MGeocoder) {
                    this.MGeocoder = new AMap.Geocoder({
                        radius: 100,
                        extensions: "all"
                    });
                }
            });
            if (autoLocation) {
                if (this.addressText.current)
                    this.addressText.current.innerText = React.language('flow.list.multiNode10')
                this.setState({
                    showMap: true,
                }, () => {
                    this._geoLocation();
                })

            }
        } else {
            this.setState({
                hasAMap: false
            })
        }
    }

    regeocoder = (a, cb) => {
        const AMap = this.AMap;
        let b = this,
            c = new AMap.Geocoder({
                radius: 1e3,
                extensions: "all"
            });
        c.getAddress(a, function (c, d) {
            if ("complete" === c && "OK" === d.info) {
                let e = d.regeocode.addressComponent,
                    f = d.regeocode.formattedAddress,
                    g = f.replace(e.province, "").replace(e.city, "").replace(e.district, "");
                b.value = {
                    province: e.province,
                    city: e.city || e.province,
                    district: e.district,
                    detail: b.detail || g,
                    lnglatXY: Array.isArray(a) ? a : [a.lng, a.lat],
                    time: Date.now()
                };
                b.detail && (b.detail = null);
                b._setLocationText(b.value);
                cb && cb()
                // BsyUtils.applyFunc(b, b.options.onStopEdit, [b.getValue(), null, b], !1)

            } else {
                b.value = null;
                cb && cb()
                // BsyUtils.applyFunc(b, b.options.onStopEdit, [null, null, b], !1)
            }

        })
    }

    _setLocationText = (value) => {

        const { lnglatVisible } = this.options;

        if (this.addressText.current) {
            if (!BsyUtils.isObjectEmpty(value)) {

                this.addressText.current.innerText = BsyUtils.address2Str(value, 'pcda');
                if (lnglatVisible) {
                    if (!BsyUtils.isObjectEmpty(value.lnglatXY)) {
                        this.latRef.current.innerText = React.language('latLon') + BsyUtils.fixDecimalPrecision(value.lnglatXY[0], 6) + ',' + BsyUtils.fixDecimalPrecision(value.lnglatXY[1], 6);
                        // this.lonRef.current.innerText = React.language('lon') + BsyUtils.fixDecimalPrecision(value.lnglatXY[0], 6);
                    }
                }

            } else {
                this.addressText.current.innerText = '';
                if (lnglatVisible) {
                    this.latRef.current.innerText = '';
                    // this.lonRef.current.innerText = '';
                }
            }
        }

    }

    _clearLocationText = () => {
        this.value = null
        this.lnglatXY = null;
        this._setLocationText(this.value);
        BsyUtils.applyFunc(this, this.options.onStopEdit, [this.value, null, this], !1)
        this.setState({
            showMap: false,
        })
    }

    getValue = () => {
        if (!BsyUtils.isObjectEmpty(this.value)) {
            return this.value
        }
        return null;
    }

    setValue = (t) => {
        const { enablePcLocation } = this.options;
        this.value = t;

        this.setState({
            showMap: !BsyUtils.isObjectEmpty(this.value) ? true : false,
        }, () => {
            if (!BsyUtils.isObjectEmpty(this.value)) {
                if (!BsyUtils.isObjectEmpty(this.value.lnglatXY)) {
                    if (enablePcLocation) {
                        this.lnglatXY = this.value.lnglatXY;
                        if (this.map) {
                            this.map.resize?.();
                            this._geoLocation();
                        }
                        this._setLocationText(this.value);
                    }
                } else {
                    this.value = null;
                    this.setState({ showMap: false })
                }
            }
        })
    }

    _geoLocation = () => {
        let a = this,
            b = this.options;

        const AMap = this.AMap;
        if (!this.geolocation) {
            this.geolocation = new AMap.Geolocation({
                zoomToAccuracy: !0,
                showButton: !1,
                showCircle: !1,
                showMarker: !1
            })
            this.map.addControl(this.geolocation)
        }

        // getLocation();
        if (!BsyUtils.isObjectEmpty(a.lnglatXY)) {
            if (a.showMaker) {
                a.showMaker.setPosition(a.lnglatXY)
            } else {
                a.showMaker = new AMap.Marker({
                    map: a.map,
                    position: a.lnglatXY
                })
            }
            a.map.setFitView()
            return;
        }

        // this.geolocation || (this.geolocation = new AMap.Geolocation({
        //         zoomToAccuracy: !0,
        //         showButton: !1,
        //         showCircle: !1,
        //         showMarker: !1
        //     })
        // ,this.map.addControl(this.geolocation))


        this.geolocation.getCurrentPosition(function (status, result) {
            a.reset = false;
            if (status == 'complete') {
                let c = result;
                console.log('complete', result);
                let d = [c.position.getLng(), c.position.getLat()];
                a.lnglatXY = d;
                let e = d;

                if (BsyUtils.isObjectEmpty(a.value)) {

                    a.regeocoder(d, function () {
                        BsyUtils.applyFunc(a, b.onStopEdit, [a.value, null, a], !1)
                    })
                } else {
                    BsyUtils.applyFunc(a, b.onStopEdit, [a.value, null, a], !1)
                    a._setLocationText(a.value);
                    e = a.positionposition
                }

                if (b.adjustable) {
                    if (a.showMaker) {
                        a.showMaker.setPosition(e)
                    } else {
                        a.showMaker = new AMap.Marker({
                            map: a.map,
                            position: e
                        })
                    }
                    a.map.setFitView()
                }
            } else {

                if (!BsyUtils.isObjectEmpty(a.value)) {
                    // if (b.adjustable) {
                    if (a.showMaker) {
                        a.showMaker.setPosition(a.position)
                    } else {
                        a.showMaker = new AMap.Marker({
                            map: a.map,
                            position: a.position
                        })
                    }
                    a.map.setFitView()
                    // }

                } else {
                    console.log(AMap)

                    AMap.plugin('AMap.CitySearch', function () {
                        if (!a.citysearch) {
                            a.citysearch = new AMap.CitySearch();
                        }

                        a.citysearch.getLocalCity(function (status, result) {
                            if (status === 'complete' && result.info === 'OK') {
                                if (result && result.city && result.bounds) {

                                    a.MGeocoder && a.MGeocoder.getLocation(result.province + result.city, function (status, result) {
                                        if (status === 'complete' && result.geocodes) {

                                            // a.showMaker.setPosition(result.geocodes[0].location)
                                            a.position = result.geocodes[0].location
                                            if (a.showMaker) {
                                                a.showMaker.setPosition(a.position)
                                            } else {
                                                a.showMaker = new AMap.Marker({
                                                    map: a.map,
                                                    position: a.position,
                                                    // anchor: "bottom-center",
                                                    // icon: icon3
                                                })



                                            }
                                            // a.map.setFitView()
                                            // a.map.setZoomAndCenter(options.mapScale, [result.geocodes[0].location.lng, result.geocodes[0].location.lat]);

                                            a.regeocoder(result.geocodes[0].location, function () {
                                                BsyUtils.applyFunc(a, b.onStopEdit, [a.value, null, a], !1)
                                            });

                                        } else {
                                            console.error(React.language('latLon.not.exist'), status, result)
                                            BsyAlertTip({
                                                type: "error",
                                                msg: React.language("latLon.not.exist"),
                                            });
                                        }
                                    });
                                }
                            } else {
                                a.element.find(".location-info1").text(result.message);
                            }
                        })
                    })
                }
                // console.error('地图接口异常', result)

                // a.element.find(".location-info1").text();

            }
        })
    }

    _createDialog = (a) => {
        var b = this,
            c = this.options,
            d = new window.FX.ConfirmDialog({
                title: React.language("only.select.Map.address"),
                width: 650,
                height: 530,
                contentWidget: {
                    rowSize: [450],
                    colSize: [610],
                    hgap: 0,
                    vgap: 15,
                    padding: 15,
                    items: [
                        [{
                            widgetName: "addressMap",
                            value: b.getValue(),
                            type: "addressmap"
                        }]
                    ]
                },
                onOk: function () {
                    var e = d.getWidgetByName("addressMap");
                    if (e.checkValidate()) {
                        var f = e.getValue();
                        if (BsyUtils.isObjectEmpty(f)) {
                            f = null;
                        }
                        b.setValue(f);
                        BsyUtils.applyFunc(b, c.onStopEdit, [f, null, b], !1)
                        d.close();
                    }
                }
            });
        d.show();

        var e = d.getWidgetByName("addressMap");
        e.setValue(this.value)
    }

    _initLocation = () => {
        const { btnWidth, btnHeight, lnglatVisible } = this.options;
        const { showMap } = this.state;
        return (
            <>
                <div className="location-content" style={{
                    display: showMap ? "flex" : 'none',
                }}>
                    <div className="location-content-info">
                        <div className="location-info1">
                            <div className="sub-head" ref={this.addressText} >{ }</div>
                            {
                                lnglatVisible ? <div className="sub-info">
                                    <div className="info-line" ref={this.latRef}></div>
                                    {/* <div className="info-line" ref={this.lonRef}></div> */}
                                </div> : ''
                            }

                        </div>
                        <div className="location-info-clear">
                            <span onClick={e => {
                                e.preventDefault();
                                e.stopPropagation()
                                this._clearLocationText()
                            }}>{React.language('clear')}</span>
                            <span onClick={e => {
                                e.preventDefault();
                                e.stopPropagation()
                                this._createDialog();
                            }}>{React.language('template.select')}</span>
                        </div>
                    </div>
                    <div className="location-content-map" id={"DashMap-" + this.zIndex} onClick={e => {
                        e.preventDefault();
                        e.stopPropagation()
                        this._createDialog();
                    }}>
                    </div>

                </div>
                <BsyButton
                    height={btnHeight}
                    width={btnWidth}
                    iconName={'icon-bby-icondingwei'}
                    mode={'white'}
                    text={React.language("widget.location.get")}
                    click={e => {

                        this.setState({
                            showMap: true,
                        }, () => {
                            this.addressText.current.innerText = React.language('flow.list.multiNode10')
                            this.value = null;
                            this.lnglatXY = null;
                            if (this.map && this.map.resize)
                                this.map.resize();
                            this._geoLocation();
                        })

                    }}
                ></BsyButton>
            </>

        )
    }

    checkValidate = () => {
        let a = this.options,
            b = this.options.allowBlank || !BsyUtils.isObjectEmpty(this.value);

        const AMap = this.AMap;
        if (BsyUtils.isObjectEmpty(AMap)) {
            return b;
        }

        if (!b) {
            this.setInvalidateTypeText(React.language('item.required'))
            return b;
        }

        if (a.limits && a.limits.length > 0 && !BsyUtils.isObjectEmpty(this.value)) {
            b = !1;
            let c = new AMap.LngLat(this.value.lnglatXY[0], this.value.lnglatXY[1]);
            BsyUtils.forEach(a.limits, function (a, d) {
                if (c.distance(d.position) < d.radius)
                    return b = !0,
                        !1
            })

            this.setInvalidateTypeText(React.language("time18"))
        }
        return b
    }

    renderDisablePane = () => {
        const { format } = this.options;
        let value = this.getValue();
        let text = BsyUtils.address2Str(value, "pcda", '-');
        return <div className="bsy_form_item_disable" data-watermark={React.language('content.empty')} >{
            text
        }</div>
    }




    render() {

        const { cssName, css, enablePcLocation, hasBrief, triggerEventButton, locationText, btnWidth, btnHeight } = this.options;
        const { showMap, hasAMap } = this.state;

        if (!hasAMap) {
            return BsyUtils.AmapError()
        }

        if (!this.isEnabled()) {
            return this.renderDisablePane()
        }
        let text = BsyUtils.address2Str(this.value, "pcda", '-');
        return (
            <div className={cssName + ' ' + (showMap ? " showMap " : '')}
                style={css}
            >
                {!enablePcLocation ? <>
                    {text ? <div className="location-info">{text}</div> : ''}
                    <BsyButton
                        height={btnHeight}
                        width={btnWidth}
                        iconName={'icon-bby-icondingwei'}
                        mode={'white'}
                        text={hasBrief ? React.language("widget.location.mobileOpen") : triggerEventButton ? triggerEventButton : locationText}
                        enable={false}
                    ></BsyButton> </> :
                    this._initLocation()
                }
            </div>
        );
    }
}
